import {ConnectType, getConnectPagePath} from '@mydata/utils/connect'
import {isAxiosError} from 'axios'

import {EXTERNAL_ROUTES} from '$constants/external-routes'
import {INTERNAL_ROUTES} from '$constants/internal-routes'
import {MYDATA_BE_API_ERROR} from '$share/constants/error'

import buildUrl from './buildUrl'

export const isUserAgreementNotFoundOrRevokeError = (error: unknown) => {
    return (
        isAxiosError(error) &&
        error.response &&
        error.response.status === MYDATA_BE_API_ERROR.약관동의_이력이_없거나_동의_철회.statusCode &&
        error.response.data === MYDATA_BE_API_ERROR.약관동의_이력이_없거나_동의_철회.errorCode // server/middlewares/error.ts 에서 response 를 바꾸고 있음.
    )
}

export const getRedirectConnectPageUrl = (rurl: string) => {
    /**
     * 마데 미동의자의 경우, 무한루프에 빠지는 경우가 있어, curl을 /mydata/home으로 고정합니다.
     * https://oss.fin.navercorp.com/Product-Planning/Myasset-QA/issues/677#issuecomment-1264957
     */
    const curl = buildUrl({pathname: EXTERNAL_ROUTES.MYDATA.HOME})
    return getConnectPagePath({type: ConnectType.NewConnection, rurl, curl})
}

const MYDATA_AGREEMENT_SKIP_PAGE = [
    INTERNAL_ROUTES.BANK_EMPTY,
    INTERNAL_ROUTES.BANK_UNUSED,
    INTERNAL_ROUTES['BANK_[ID]_SIMPLEPAY'],
    INTERNAL_ROUTES.CARD_EMPTY,
    INTERNAL_ROUTES.BANK,
    INTERNAL_ROUTES.CARD_APPROVAL,
    INTERNAL_ROUTES.CARD_BILL,
    INTERNAL_ROUTES.EFIN,
    INTERNAL_ROUTES.EFIN_EMPTY,
]

export const isMyDataAgreementRequiredPage = (resolvedUrl: string) => {
    const pathname = resolvedUrl.split('?')[0]

    return !MYDATA_AGREEMENT_SKIP_PAGE.includes(pathname)
}

const SENSITIVE_MEMBER_INFO_EXCLUDED_PAGE = [
    INTERNAL_ROUTES.BANK_EMPTY,
    INTERNAL_ROUTES.CARD_EMPTY,
    INTERNAL_ROUTES.EFIN_EMPTY,
    INTERNAL_ROUTES['INSURANCE_CONTENTS_[ID]'],
]

export const isSensitiveMemberInfoExcludedPage = (resolvedUrl: string) => {
    const pathname = resolvedUrl.split('?')[0]

    return SENSITIVE_MEMBER_INFO_EXCLUDED_PAGE.includes(pathname)
}
